import type { ReactNode } from "react"

interface FinancialPageLayoutProps {
  children: ReactNode
  className?: string
}

export const FinancialPageLayout: React.FC<FinancialPageLayoutProps> = ({ children, className = "" }) => (
  <main
    className={`h-[calc(100dvh-150px)] w-full min-w-0 overflow-x-hidden overflow-y-auto bg-slate-50/70 p-2 pb-24 md:h-full md:p-3 md:pb-8 xl:p-4 ${className}`}
  >
    <div className="flex w-full min-w-0 flex-col gap-4 md:gap-5 xl:gap-6">{children}</div>
  </main>
)
